import { createError } from '@adv-frontend/error';

import { createHref } from '../createHref';
import { buildHistory, HistoryAdapter } from '../buildHistory';
import { RateLimiter } from './RateLimiter';

const RouterLimitExceededError = createError('RouterLimitExceededError');

export function buildClientHistory(historyAdapter: HistoryAdapter) {
    const history = buildHistory(historyAdapter);
    const { getNavigationMethod, push, replace } = history;
    const max = 20;
    const limiter = new RateLimiter({
        max,
        errorProducer: () =>
            new RouterLimitExceededError(`Количество изменений url превысило ${max} за 1 секунду`, { cause: null }),
    });

    history.push = (to, state) => {
        const href = createHref(to);
        const navigationMethod = getNavigationMethod(href);

        if (navigationMethod === 'spa') {
            limiter.checkLimit();
            return push(to, state);
        }

        if (navigationMethod === 'mpa') {
            return window.location.assign(href);
        }

        navigationMethod();
    };

    history.replace = (to, state) => {
        const href = createHref(to);
        const navigationMethod = getNavigationMethod(href);

        if (navigationMethod === 'spa') {
            limiter.checkLimit();
            return replace(to, state);
        }

        if (navigationMethod === 'mpa') {
            return window.location.replace(href);
        }

        navigationMethod();
    };

    return history;
}
